export default __webpack_public_path__ + "static/media/img-0089-japan-premium-face.fa3d048f.png";